import React, { Component, PureComponent } from 'react'
import {
  Redirect,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import CONSTANTS from '../../../constants'
import { pushEventToGTM } from '../../../helpers/trackerManager'
import { slugify } from '../../../helpers/functions'
import Icon from '../../buttons/Icon'
import EditButton from '../../buttons/EditButton'
import ConfirmationDialog from '../../Breadcrumb/ConfirmationDialog'
import { setDialogConfirmationStepChange, CurrentStepSetAction } from '../../../actions/action'

const mapStateToProps = state => state
const mapDispatchToProps = { setDialogConfirmationStepChange, CurrentStepSetAction }

class DealerMobile extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      redirectToLocation: false
    }
    this.confirmAndRedirect = this.confirmAndRedirect.bind(this)
  }

  confirmAndRedirect(isRedirect) {
    if (isRedirect) {
      this.setState({ redirectToLocation: true })
      this.props.CurrentStepSetAction(2);
    }
    // Reset id of visible dialog step change.
    this.props.setDialogConfirmationStepChange('')
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.redirectToLocation) { this.setState({ redirectToLocation: false }) }
  }

  render() {
    const URL = CONSTANTS.SITE_ROUTS.LISTDEALERSPAGE + '/' + slugify(this.props.store.dealer.city)
    return (
      <div className='upperContainer'>
           <div className="dealerContainer">
               <div className="titleDealer">{this.props.name ? this.props.name : undefined}</div>
               {!this.props.store.isEditMode &&
                <EditButton onClick={(e) => {

                    pushEventToGTM({
                    pageName: 'all',
                    eventAction: 'Redirection::Internal::Modify',
                    eventLabel: 'header_modify_dealer'
                    })
                    if (this.props.isExistPrestationWithForfait) { this.props.setDialogConfirmationStepChange('dealerChange') }
                    else {
                    this.setState({ redirectToLocation: true })
                    this.props.CurrentStepSetAction(2);
                    }
                }}
                />}
            </div>
            <div className="adressContainer">
                <div className="adressTitle">
                    <span className="iconLocationMobile"></span>{" "}
                    {CONSTANTS.LABELS.header_modification_address}
                </div>
                <div className="adressContent">
                        {this.props.adress}
                </div>
            </div>
       

       
        {this.props.store.visibaleDialogId == 'dealerChange' &&
          <ConfirmationDialog isConfirmedDialog={(e) => {
            this.confirmAndRedirect(e)
          }}
          />}

        {this.state.redirectToLocation &&
          !!Object.values(this.props.store.dealer).length &&
          <Switch>
            <Redirect
              push
              to={{ pathname: String(URL) }}
            />
          </Switch>}

      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DealerMobile)
